import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSelectedUnits } from '../SelectUnits/selectors'
import { actions } from './reducer'
import { SelectUnit } from '../SelectUnits/types'

const MIN_PRORATE_TOTAL = 5

export const getUnitProrateTotal = (subTotal: number) => {
  if (subTotal <= 0) return '0.00'

  const today = new Date()
  const totalDays = new Date(
    today.getFullYear(),
    today.getMonth() + 1,
    0
  ).getDate()
  const daysLeft = Math.max(totalDays - today.getDate() - 1, 0)

  const pricePerDay = subTotal / totalDays
  const prorateTotal = daysLeft * pricePerDay
  return Math.max(prorateTotal, MIN_PRORATE_TOTAL).toFixed(2)
}

export const UseSetTotalEffect = () => {
  const dispatch = useDispatch()
  const selectedUnits = useSelector(getSelectedUnits) as SelectUnit[]

  const onProrateTotal = React.useCallback(
    (subTotal: number) => {
      const prorateTotal = getUnitProrateTotal(subTotal)
      dispatch(actions.onProrateTotal(prorateTotal.toString()))
    },
    [dispatch]
  )

  React.useEffect(() => {
    let subTotal = 0
    selectedUnits.forEach((x) => {
      const length = Number(x.value)
      if (length === 1) subTotal += x.price
      else {
        for (let i = 0; i < length; i++) {
          subTotal += x.price
        }
      }
    })

    onProrateTotal(subTotal)
    dispatch(actions.onMonthlyTotal(subTotal.toString()))
  }, [dispatch, onProrateTotal, selectedUnits])
}
